import {createFileRoute} from '@tanstack/react-router'
import LeagueOfPlayersPage from '../../landing/LeagueOfPlayersPage'

export const Route = createFileRoute('/leaderboards/players')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LeagueOfPlayersPage />
}
